import { IUser, UserState } from './types';

const getters = {
  getCurrentUserData(state: UserState): IUser | undefined {
    return state.currentUser;
  },

  getCurrentUserLocale(state: UserState): string {
    return state.currentUser ? state.currentUser.locale : 'en';
  },

  getCurrentUserName(state: UserState): string {
    return state.currentUser ? state.currentUser.name : '';
  },

  getCurrentUserEmail(state: UserState): string {
    return state.currentUser ? state.currentUser.email : '';
  },

  getCurrentUserRole(state: UserState): string {
    const extractedRoles = state.currentUser && state.currentUser.roles
      ? state.currentUser.roles.filter(role => role.startsWith('Role-'))
      : [];
    return extractedRoles.length === 1 ? extractedRoles[0].substring(5) : '';
  },
  getMasterAccounts(state: UserState) {
    return state.masterAccounts;
  },
  getSelectedMasterAccount(state: UserState) {
    return state.selectedMasterAccount;
  }
};

export default getters;
